<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { Primitive } from 'reka-ui'

const props = withDefaults(defineProps<{
  as?: any
  class?: HTMLAttributes['class']
}>(), {
  as: 'footer',
})

const slots = defineSlots<{
  left?: (props?: object) => any
  default?: (props?: object) => any
  right?: (props?: object) => any
  top?: (props?: object) => any
  bottom?: (props?: object) => any
}>()

const appConfig = {
  ui: {
    footer: {
      slots: {
        root: '',
        top: 'py-8 lg:py-12',
        bottom: 'py-8 lg:py-12',
        container: 'py-8 lg:py-4 lg:flex lg:items-center lg:justify-between lg:gap-x-3',
        left: 'flex items-center justify-center lg:justify-start lg:flex-1 gap-x-1.5 mt-3 lg:mt-0 lg:order-1',
        center: 'mt-3 lg:mt-0 lg:order-2 flex items-center justify-center',
        right: 'lg:flex-1 flex items-center justify-center lg:justify-end gap-x-1.5 lg:order-3',
      },
    },
  },
}
</script>

<template>
  <Primitive :as="as" :class="cn(appConfig.ui.footer.slots.root, props.class)">
    <div v-if="!!slots.top" :class="appConfig.ui.footer.slots.top">
      <slot name="top" />
    </div>

    <div :class="appConfig.ui.footer.slots.container">
      <div :class="appConfig.ui.footer.slots.right">
        <slot name="right" />
      </div>

      <div :class="appConfig.ui.footer.slots.center">
        <slot />
      </div>

      <div :class="appConfig.ui.footer.slots.left">
        <slot name="left" />
      </div>
    </div>

    <div v-if="!!slots.bottom" :class="appConfig.ui.footer.slots.bottom">
      <slot name="bottom" />
    </div>
  </Primitive>
</template>
